export default __webpack_public_path__ + "static/media/part_3.62014b00.svg";